/**
 * @desc 获取系统列表信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** factoryCode */
  factoryCode?: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.MonitorURLResponse>> {
  return defHttp.get({
    url: '/web/IOT/listSystemBaseInfos',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.MonitorURLResponse>> {
  return defHttp.get({
    url: '/mock/web/IOT/listSystemBaseInfos',

    params,
  });
}
